import PageTitle from "../../../components/PageTitle"
import TabSwitcher from "../../../components/TabSwitcher"
import Template from "../../../components/Template"
import * as S from "../style"
import { useState, useEffect } from 'react';
import { obterListaPessoaRelacao, adicionarPessoaRelacao, excluirPessoaRelacao, alterarPessoaRelacao } from '../../../services/api/Configuracoes/PessoaRelacao/index';
import Table from "../../../components/Table";
import ListTable from "../../../components/List";
import { IObterListaPessoaRelacaoResponse, IAlterarPessoaRelacao } from '../../../services/models/Configuracoes/PessoaRelacao/index';
import Input from "../../../components/Input";
import * as yup from "yup"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../../../components/Button";
import ItemsList, { HeaderList, ListItem } from "../../../components/ItemsList";
import ModalAction from "../../../components/ModalAction";
import { PencilSimple, Trash } from "phosphor-react";
import ActionButton from "../../../components/ActionButton";
import { usePermissionsStore } from "../../../stores/PermissionsStore";

const AddRelationSchema = yup.object({
    descricao: yup.string().required("O nome da relação é obrigatório.")
})

interface relationItem {
    id: number;
    descricao: string;
    isAtivo: boolean;
}

const PeopleRelation = () => {
    const [view, setView] = useState<number>(0)
    const [relacaoList, setRelacaoList] = useState<any>(null)

    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
    const [showEditModal, setShowEditModal] = useState<boolean>(false)
    const [itemToDelete, setItemToDelete] = useState<relationItem | null>(null)
    const [itemToEdit, setItemToEdit] = useState<relationItem | null>(null)

    useEffect(() => {
        view === 0 && ObterListaPessoaRelacao()
    }, [view])

    const {
        handleSubmit,
        control,
        reset,
        formState: {
            errors,
            isValid
        }
    } = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
        resolver: yupResolver(AddRelationSchema)
    })

    const ObterListaPessoaRelacao = async () => {
        let res = await obterListaPessoaRelacao()
        setRelacaoList(res)
    }

    const AdicionarPessoaRelacao = async (data: any) => {
        let body = {
            ...data
        }

        await adicionarPessoaRelacao(body).then(() => {
            reset()
        })
    }

    const ExcluirPessoaRelacao = async (idPessoaRelacao: number) => {
        await excluirPessoaRelacao({ idPessoaRelacao })
        ObterListaPessoaRelacao()
    }

    const EditarPessoaRelacao = async (newPessoa: IAlterarPessoaRelacao) => {
        await alterarPessoaRelacao(newPessoa)
        ObterListaPessoaRelacao()
    }

    const handleShowDeleteModal = (item: { id: number, descricao: string, isAtivo: boolean }) => {
        setItemToDelete(item)
        setShowDeleteModal(true)
    }

    const handleShowEditModal = (item: relationItem) => {
        setItemToEdit(item)
        setShowEditModal(true)
    }

    const findPermission = usePermissionsStore((state) => state.findPermission);

    const permissions = findPermission(3);

    // PARA TESTE
    // const permissions = {
    //     permiteInserir: false,
    //     permiteAlterar: false,
    //     permiteExcluir: false,
    // }

    const {
        permiteInserir,
        permiteAlterar,
        permiteExcluir
    } = permissions;

    const menuItems = permiteInserir ?
        [
            "Dados",
            "Adicionar"
        ] : [
            "Dados"
        ]

    const headerList = permiteAlterar || permiteExcluir ?
        [
            "Descrição",
            "Status",
            "Ações"
        ] : [
            "Descrição",
            "Status"
        ]

    return (
        <Template>
            <PageTitle>
                Relação de Pessoas
            </PageTitle>
            <TabSwitcher
                list={menuItems}
                view={view}
                setView={setView}
            />
            <S.Content>
                <S.ControlView active={view === 0}>
                    {
                        relacaoList ? (
                            <ItemsList>
                                <HeaderList items={headerList} />
                                {
                                    relacaoList.map((item: any, index: any) => {
                                        return (
                                            <ListItem key={index}>
                                                <div>{item.descricao}</div>
                                                <div>{item.isAtivo ? "Ativo" : "Inativo"}</div>
                                                {
                                                    (
                                                        permiteAlterar ||
                                                        permiteExcluir
                                                    ) && (
                                                        <div>
                                                            {
                                                                permiteAlterar && (
                                                                    <ActionButton act="edit" onClick={() => handleShowEditModal(item)}>
                                                                        <PencilSimple />
                                                                    </ActionButton>
                                                                )
                                                            }
                                                            {
                                                                permiteExcluir && (
                                                                    <ActionButton act="delete" onClick={() => handleShowDeleteModal(item)}>
                                                                        <Trash />
                                                                    </ActionButton>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </ListItem>
                                        )
                                    })
                                }
                            </ItemsList>
                        ) : (<p>Carregando...</p>)
                    }
                </S.ControlView>
                <S.ControlView active={view === 1} id="addRelation" onSubmit={handleSubmit((data) => AdicionarPessoaRelacao(data))}>
                    <S.GridItem cols={2}>
                        <Input id="descricao" name="descricao" label="Nome da relação" control={control} error={errors?.descricao?.message} />
                    </S.GridItem>
                    {
                        isValid && (
                            <S.GridItem cols={6}>
                                <Button type="submit" form="addRelation">Adicionar</Button>
                            </S.GridItem>
                        )
                    }
                </S.ControlView>
            </S.Content>
            {
                showDeleteModal && itemToDelete && (
                    <ModalAction
                        type="delete"
                        onConfirm={() => ExcluirPessoaRelacao(itemToDelete.id)}
                        onClose={() => setShowDeleteModal(false)}
                        title="Excluir relação"
                        item={itemToDelete}
                    />
                )
            }
            {
                showEditModal && itemToEdit && (
                    <ModalAction
                        type="edit"
                        onConfirm={(e) => EditarPessoaRelacao(e)}
                        onClose={() => setShowEditModal(false)}
                        title="Editar relação"
                        item={itemToEdit}
                    />
                )
            }
        </Template>
    )
}

export default PeopleRelation